import { rootProtectedPath, services } from "data/authData";
import MoveToInboxRounded from "@mui/icons-material/MoveToInboxRounded";
import NotesIcon from "@mui/icons-material/Notes";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import InventoryIcon from "@mui/icons-material/Inventory";
import GroupsIcon from "@mui/icons-material/Groups";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import StoreIcon from "@mui/icons-material/Store";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DatasetIcon from "@mui/icons-material/Dataset";
import BookIcon from "@mui/icons-material/Book";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMadeIcon from "@mui/icons-material/CallMade";
import StyleIcon from '@mui/icons-material/Style';
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";

export const customQuereiesDrawerElements = {
	planning_sale_query: {
		name: "Planning Sale Query",
		key: "planning_sale_query",
		display: true,
		icon: <NotesIcon />,
	},
	all_channel_dispatch: {
		name: "All Channel Dispatch",
		key: "all_channel_dispatch",
		display: true,
		icon: <LocalShippingIcon />,
	},

	inventory_snapshot: {
		name: "Inventory Snapshot",
		key: "inventory_snapshot",
		display: true,
		icon: <InventoryIcon />,
	},
	git: {
		name: "GIT",
		key: "git",
		display: true,
		icon: <DepartureBoardIcon />,
	},
	tir: {
		name: "Inward Register",
		key: "tir",
		display: true,
		icon: <ArrowCircleRightIcon />,
	},
	ecom_sales: {
		name: "ECOM SALES",
		key: "ecom_sales",
		display: true,
		icon: <LocalMallIcon />,
	},
	ebo_sales: {
		name: "EBO SALES",
		key: "ebo_sales",
		display: true,
		icon: <StoreIcon />,
	},
	ecomm: {
		name: "Ecomm",
		key: "ecomm",
		display: true,
		icon: <StorefrontIcon />,
		types: {
			uc_sale_report: {
				name: "UC Sale Report",
				key: "uc_sale_report",
				display: true,
				icon: <ReceiptLongIcon />,
			},
			ginesys_sale_report: {
				name: "Ginesys Sale Report",
				key: "ginesys_sale_report",
				display: true,
				icon: <ReceiptLongIcon />,
			},
			return_report: {
				name: "Return Report",
				key: "return_report",
				display: true,
				icon: <AssignmentReturnIcon />,
			},
		},
	},
	insurance: {
		name: "Insurance",
		key: "insurance",
		display: true,
		icon: <HealthAndSafetyIcon />,
	},

	soh: {
		name: "SOH",
		key: "soh",
		display: true,
		icon: <Inventory2Icon />,
		types: {
			shopify_soh: {
				name: "Shopify SOH",
				key: "shopify_soh",
				display: true,
				icon: <Inventory2Icon />,
			},
			historical_soh: {
				name: "Historical SOH",
				key: "historical_soh",
				display: true,
				icon: <Inventory2Icon />,
			},
			ebo_soh_daily: {
				name: "EBO SOH Daily",
				key: "ebo_soh_daily",
				display: true,
				icon: <MoveToInboxRounded />,
			},
		},
	},
	store_register: {
		name: "Store Register",
		key: "store_register",
		display: true,
		icon: <BookIcon />,
		types: {
			goods_receive_register: {
				name: "Goods Receive Register",
				key: "goods_receive_register",
				display: true,
				icon: <CallReceivedIcon />,
			},
			goods_return_register: {
				name: "Goods Return Register",
				key: "goods_return_register",
				display: true,
				icon: <CallMadeIcon />,
			},
		},
	},
	rtv: {
		name: "RTV",
		key: "rtv",
		display: true,
		icon: <Inventory2Icon />,
		types: {
			ebo_rtv: {
				name: "EBO RTV",
				key: "ebo_rtv",
				display: true,
				icon: <Inventory2Icon />,
			},
			mbo_rtv: {
				name: "MBO RTV",
				key: "mbo_rtv",
				display: true,
				icon: <Inventory2Icon />,
			},
		},
	},
	customer_cohort: {
		name: "Customer Cohort",
		key: "customer_cohort",
		display: true,
		icon: <ManageAccountsIcon />,
		types: {
			customer_count: {
				name: "Customer Count",
				key: "customer_count",
				display: true,
				icon: <GroupsIcon />,
			},
			count_of_bill: {
				name: "Count of Bill",
				key: "count_of_bill",
				display: true,
				icon: <ReceiptLongIcon />,
			},
			realised_value: {
				name: "Realised Value",
				key: "realised_value",
				display: true,
				icon: <CurrencyRupeeIcon />,
			},
		},
	},
	item_master: {
		name: "Item Master",
		key: "item_master",
		display: true,
		icon: <DatasetIcon />,
	},
	style_soh_contribution: {
		name: "Style Soh Contribution",
		key: "style_soh_contribution",
		display: true,
		icon: <StyleIcon />,
	},
	all_channel_sales: {
		name: "All Channel Sales",
		key: "all_channel_sales",
		display: true,
		icon: <LocalMallIcon />,
	},
	productwise_session: {
		name: "Productwise Session",
		key: "productwise_session",
		display: true,
		icon: <AnalyticsIcon />,
	},
	total_in_total_out: {
		name: "Total in total out",
		key: "total_in_total_out",
		display: true,
		icon: <ImportExportIcon />,
	},
};

export const selectOptKeyName = "select_options";
export const replenishmentParamName = "tab";

export const allOption = "ALL";

export const planningSaleQueryPath = `/${rootProtectedPath}/${services.custom_queries.path}/${customQuereiesDrawerElements.planning_sale_query.key}`;
